import React from 'react';
import './styles.css';
import { Row, Col, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const ButtonBackData = ({ onClick }) => {
  const [t] = useTranslation();
  return (
    <Row justify="start">
      <Col span={12} align="start">
        <Button type="text" className="button-back" onClick={onClick}>
          <ArrowLeftOutlined />
          {t('pages.data.components.buttonBackText')}
        </Button>
      </Col>
    </Row>
  );
};

export default ButtonBackData;
